/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

// import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database'

import { User } from '@touchplan/common';
import { FancyFirebaseObject } from '../base/FancyFirebaseObject';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';

export class UserObject extends FancyFirebaseObject<User> {
	constructor(angularLand: AngularLandConnection, path: RefOrObservable) {
		super(angularLand, path);
	}

	public $$updated(child: any) {
		if (!child || !child.payload.exists()) {
			return null;
		}
		// return new User(child.payload.val());
		const newChild = child.payload.val();
		newChild.update = this.update;

		newChild.parsedName = this.parsedName(newChild);
		newChild.$id = child.key;

		return newChild;
	}

	public parsedName(userData) {
		if (!userData) {
			return 'userless';
		}
		if (!userData.firstName && !userData.lastName) {
			return userData.email;
		}
		return (
			(userData.firstName ? userData.firstName : '') + ' ' + (userData.lastName ? userData.lastName : '')
		);
	}

	//really half-assed method just to get this working, design a proper solution when necessary
	public update = (obj) => {
		return this.listRef.update(obj);
	};
}
